export default __webpack_public_path__ + "static/media/info.2b0fba41.svg";